import { styled } from '@mui/material/styles';
import { Box, Paper } from '@mui/material';

interface ProgressIndicatorProps {
  value: number;
}

export const StyledSidebar = styled(Box)(({ theme }) => ({
  width: '320px',
  backgroundColor: theme.palette.primary[400],
  color: 'white',
  position: 'relative',
  overflow: 'hidden',
  flexShrink: 0,
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
}));

export const ContainerBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  backgroundColor: theme.palette.background.default,
  padding: theme.spacing(3),
  justifyContent: 'center',
  alignItems: 'center',
  overflow: 'auto',
}));

export const DecorativeCircle = styled(Box)({
  position: 'absolute',
  borderRadius: '50%',
  background: 'rgba(255, 255, 255, 0.1)',
  zIndex: 0,
});

export const SidebarContent = styled(Box)(({ theme }) => ({
  padding: theme.spacing(5, 4),
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  zIndex: 1,
}));

export const ProgressBar = styled(Box)(({ theme }) => ({
  height: 6,
  borderRadius: 3,
  backgroundColor: 'rgba(255, 255, 255, 0.3)',
  marginBottom: theme.spacing(1),
}));

export const ProgressIndicator = styled(Box)<ProgressIndicatorProps>(({ value }) => ({
  width: `${value}%`,
  height: '100%',
  borderRadius: 3,
  backgroundColor: 'white',
  transition: 'width 0.3s ease',
}));

export const FormCard = styled(Paper)(() => ({
  maxWidth: '1000px',
  width: '100%',
  margin: '0 auto',
  borderRadius: '12px',
  overflow: 'visible',
  display: 'flex',
  boxShadow: '0 10px 25px rgba(0,0,0,0.12)',
}));

export const FormContentContainer = styled(Box)(({ theme }) => ({
  flex: 1,
  padding: theme.spacing(4, 6),
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(3, 4, 4),
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(2, 2, 4),
  },
}));